<template>
  <div class="mobile-filter">
    <div class="mobile-filter-content">
      <district-filter
        :selected-ics="selectedIcs"
        :selected-districts="selectedDistricts"
        @changeDistrict="$emit('changeDistrict', $event)"
      />
    </div>
  </div>
</template>

<script>
import DistrictFilter from '@/components/Stock/Filters/DistrictFilter';

export default {
  props: [
    'selectedIcs',
    'selectedDistricts',
  ],
  components: {
    DistrictFilter,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.mobile-filter {
  margin: 0;
  padding: 0;
}

.mobile-filter-content {
  padding: 5px 15px 15px 15px;
}

.mobile-filter-content .title {
  line-height: 34px;
}

.close-button {
  font-size: 28px;
  line-height: 34px;
}
</style>
